"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SITE_SELECT_CODE = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CDialog = _interopRequireDefault(require("01_core/components/materials/CDialog"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CMultiToggle = _interopRequireDefault(require("01_core/components/materials/CMultiToggle"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _DisplayField = _interopRequireDefault(require("01_core/components/materials/DisplayField"));
var _SuggestBox = _interopRequireDefault(require("01_core/components/materials/SuggestBox"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const GridLabel = (0, _styles.styled)(_Grid.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    flexGrow: 100
  };
});

/**
 * 勤務場所選択部品
 * @prop {bool} [isEntry] - 報告画面からの呼び出しかどうか
 *                          default:true=報告画面からの呼び出し、検索画面の場合はfalse指定
 * @prop {object} entries - 勤務場所選択オブジェクト
 * @prop {string} [entries.siteSelectCd] - 拠点選択コード（拠点選択／拠点入力）
 * @prop {string} [entries.tdfkCd] - 都道府県コード
 * @prop {string} [entries.kaishaCd] - 会社コード
 * @prop {string} [entries.areaCd] - 地域コード
 * @prop {string} [entries.siteNo] - 拠点番号
 * @prop {string} [entries.siteOtherNm] - 拠点名（その他）
 * @prop {string} [entries.goutou] - 号棟 ※報告画面の場合のみ
 * @prop {string} [entries.floor] - フロア（画面表示上は階）※報告画面の場合のみ
 * @prop {string} [entries.workspace] - 作業スペース（画面表示上はフロア）※報告画面の場合のみ
 * @prop {string} [entries.label] - ラベル
 * @prop {function} onChange - 変更された拠点のデータを受け取る関数
 * シグネチャ：function(object)) => void
 * object：勤務場所選択オブジェクト
 * { siteSelectCd:string, kaishaCd:string, areaCd:string, siteNo:string,
 *    tdfkCd:string, siteOtherNm:string, goutou:string, floor:string, workspace:string, label:string }
 */

/** 拠点選択コード（拠点選択／拠点入力） */
const SITE_SELECT_CODE = exports.SITE_SELECT_CODE = {
  SELECT: '1',
  INPUT: '2'
};
class WorkplaceInfo extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "checkReady", () => {
      const {
        kaishaList,
        initAreaList,
        initSiteList
      } = this.state;
      return kaishaList.length > 0 && initAreaList && initSiteList;
    });
    // 地域リスト取得（会社が指定されている場合のみ処理）
    _defineProperty(this, "getAreaList", (initialized, kaishaCd) => {
      // 会社が指定されている場合のみ処理する
      if (!kaishaCd) {
        return;
      }
      const {
        intl,
        callAPI,
        openInfoBar
      } = this.props;
      const sendData = {
        kaishaCd
      };
      callAPI(_APIs.AREA_SELECT_SEARCH, sendData).then(response => {
        const areaList = response.data ? response.data : [];
        this.setState({
          areaList
        });
        if (initialized) {
          this.setState({
            initAreaList: areaList
          });
        }
        if (this.state.dialogOpened && response.data === null) {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
            id: _labelConsts.LABEL.PANDE_NO_AREA_LIST
          }));
          return;
        }
      });
    });
    // 拠点リスト取得（会社・地域が両方指定されている場合のみ処理）
    _defineProperty(this, "getSiteList", (initialized, kaishaCd, areaCd) => {
      // 会社・地域が両方指定されている場合のみ処理する
      if (!(kaishaCd && areaCd)) {
        return;
      }
      const {
        intl,
        callAPI,
        openInfoBar
      } = this.props;
      const sendData = {
        kaishaCd,
        areaCd
      };
      callAPI(_APIs.AREA_SITE_SELECT_SEARCH, sendData).then(response => {
        const siteList = response.data ? response.data : [];
        this.setState({
          siteList
        });
        if (initialized) {
          this.setState({
            initSiteList: siteList
          });
        }
        if (this.state.dialogOpened && response.data === null) {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
            id: _labelConsts.LABEL.PANDE_NO_AREA_SITE_LIST
          }));
          return;
        }
      });
    });
    // ダイアログを開く
    _defineProperty(this, "handleOpen", () => {
      this.setState({
        dialogOpened: true,
        cancelled: false
      });
    });
    // 入力変更
    _defineProperty(this, "handleOnChange", key => value => {
      const {
        setValue
      } = this.props;
      let newEntries = _objectSpread(_objectSpread({}, this.state.entries), {}, {
        [key]: value
      });

      // siteSelectCd変更時は相互排他側の項目を即時クリアしてRHFへも同期
      if (key === 'siteSelectCd') {
        if (value === SITE_SELECT_CODE.SELECT) {
          newEntries = _objectSpread(_objectSpread({}, newEntries), {}, {
            tdfkCd: '',
            siteOtherNm: ''
          });
          setValue && setValue('reportTargetWorkplace.tdfkCd', '', {
            shouldValidate: false,
            shouldDirty: false
          });
          setValue && setValue('reportTargetWorkplace.siteOtherNm', '', {
            shouldValidate: false,
            shouldDirty: false
          });
        } else if (value === SITE_SELECT_CODE.INPUT) {
          newEntries = _objectSpread(_objectSpread({}, newEntries), {}, {
            kaishaCd: '',
            areaCd: '',
            siteNo: ''
          });
          setValue && setValue('reportTargetWorkplace.kaishaCd', '', {
            shouldValidate: false,
            shouldDirty: false
          });
          setValue && setValue('reportTargetWorkplace.areaCd', '', {
            shouldValidate: false,
            shouldDirty: false
          });
          setValue && setValue('reportTargetWorkplace.siteNo', '', {
            shouldValidate: false,
            shouldDirty: false
          });
        }
      }
      this.setState({
        entries: newEntries
      });
      if (setValue) {
        setValue("reportTargetWorkplace.".concat(key), value, {
          shouldValidate: false,
          shouldDirty: false
        });
      }
    });
    // OK（設定）押下
    _defineProperty(this, "handleSubmit", async () => {
      const {
        intl,
        openInfoBar,
        trigger
      } = this.props;
      const {
        entries
      } = this.state;
      const fieldsToValidate = entries.siteSelectCd === SITE_SELECT_CODE.SELECT ? ['reportTargetWorkplace.kaishaCd', 'reportTargetWorkplace.areaCd', 'reportTargetWorkplace.siteNo'] : ['reportTargetWorkplace.tdfkCd', 'reportTargetWorkplace.siteOtherNm'];
      let isValid = true;
      if (trigger) {
        isValid = await trigger(fieldsToValidate);
      }
      if (isValid) {
        this.setEntry();
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
          id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
        }));
      }
    });
    _defineProperty(this, "getListKaishaNm", (kaishaCd, kaishaList) => {
      const data = kaishaList.find(e => e.kaishaCd === kaishaCd);
      return _stringUtil.default.emptyToHyphen(data ? data.kaishaRk : _stringConsts.STRING_CONSTS.EMPTY);
    });
    _defineProperty(this, "getListAreaNm", (areaCd, areaList) => {
      const data = areaList.find(e => e.areaCd === areaCd);
      return _stringUtil.default.emptyToHyphen(data ? data.areaNm : _stringConsts.STRING_CONSTS.EMPTY);
    });
    _defineProperty(this, "getListSiteNm", (siteNo, siteList) => {
      const data = siteList.find(e => e.siteNo === siteNo);
      return _stringUtil.default.emptyToHyphen(data ? data.siteNm : _stringConsts.STRING_CONSTS.EMPTY);
    });
    _defineProperty(this, "getLabelNm", (entries, kaishaList, areaList, siteList) => {
      const {
        intl,
        isEntry,
        getCodeName
      } = this.props;
      const {
        siteSelectCd,
        tdfkCd,
        kaishaCd,
        areaCd,
        siteNo,
        siteOtherNm,
        goutou,
        floor,
        workspace
      } = entries;
      let labelNm = _stringConsts.STRING_CONSTS.EMPTY;
      if (!(kaishaCd || areaCd || siteNo || tdfkCd || siteOtherNm || goutou || floor || workspace)) {
        return labelNm;
      }
      switch (siteSelectCd) {
        case SITE_SELECT_CODE.SELECT:
          if (kaishaCd !== _stringConsts.STRING_CONSTS.EMPTY) {
            labelNm = labelNm + this.getListKaishaNm(entries.kaishaCd, kaishaList);
          }
          if (areaCd !== _stringConsts.STRING_CONSTS.EMPTY) {
            labelNm = labelNm + _stringUtil.default.encloseCirKakko(this.getListAreaNm(entries.areaCd, areaList));
          }
          if (siteNo !== _stringConsts.STRING_CONSTS.EMPTY) {
            labelNm = labelNm + this.getListSiteNm(entries.siteNo, siteList);
          }
          break;
        case SITE_SELECT_CODE.INPUT:
          if (tdfkCd !== _stringConsts.STRING_CONSTS.EMPTY) {
            labelNm = labelNm + _stringUtil.default.encloseCirKakko(getCodeName(_CodeConsts.CODE.TDFK.KBN, tdfkCd));
          }
          if (siteOtherNm !== _stringConsts.STRING_CONSTS.EMPTY) {
            labelNm = labelNm + siteOtherNm;
          } else if (!isEntry) {
            labelNm = labelNm + intl.formatMessage({
              id: _labelConsts.LABEL.PANDE_ALL_SITE_NOT_ON_THE_LIST
            });
          }
          break;
        default:
          break;
      }
      if (isEntry) {
        labelNm = labelNm + _stringConsts.STRING_CONSTS.SLASH_ZENKAKU + _stringUtil.default.emptyToHyphen(goutou) + _stringConsts.STRING_CONSTS.SLASH_ZENKAKU + _stringUtil.default.emptyToHyphen(floor) + intl.formatMessage({
          id: _labelConsts.LABEL.CORE_FLOOR
        }) + _stringConsts.STRING_CONSTS.SLASH_ZENKAKU + _stringUtil.default.emptyToHyphen(workspace);
      }
      return labelNm;
    });
    // 入力内容を親へ反映
    _defineProperty(this, "setEntry", () => {
      const {
        isEntry,
        onChange,
        setValue
      } = this.props;
      const {
        entries,
        kaishaList,
        areaList,
        siteList
      } = this.state;
      const labelNm = this.getLabelNm(entries, kaishaList, areaList, siteList);
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        initAreaList: this.state.areaList,
        initSiteList: this.state.siteList,
        entries: _objectSpread(_objectSpread({}, this.state.entries), {}, {
          label: labelNm
        }),
        initEntries: _objectSpread(_objectSpread({}, this.state.entries), {}, {
          label: labelNm
        })
      }));
      let resultEntries = _objectSpread({}, this.state.entries);
      if (entries.siteSelectCd === SITE_SELECT_CODE.SELECT) {
        resultEntries['tdfkCd'] = _stringConsts.STRING_CONSTS.EMPTY;
        resultEntries['siteOtherNm'] = _stringConsts.STRING_CONSTS.EMPTY;
      }
      if (entries.siteSelectCd === SITE_SELECT_CODE.INPUT) {
        resultEntries['kaishaCd'] = _stringConsts.STRING_CONSTS.EMPTY;
        resultEntries['areaCd'] = _stringConsts.STRING_CONSTS.EMPTY;
        resultEntries['siteNo'] = _stringConsts.STRING_CONSTS.EMPTY;
      }
      if (!isEntry) {
        delete resultEntries['goutou'];
        delete resultEntries['floor'];
        delete resultEntries['workspace'];
      }
      onChange(resultEntries);
      if (setValue) {
        setValue('reportTargetWorkplaceLabel', labelNm, {
          shouldValidate: false,
          shouldDirty: false
        });
      }
      this.dialogClose();
    });
    // ダイアログクローズ
    _defineProperty(this, "dialogClose", () => {
      this.setState({
        dialogOpened: false
      });
    });
    // キャンセル
    _defineProperty(this, "handleCancel", () => {
      // キャンセル・閉じるボタンの場合は変更前の情報を再設定
      if (this.state.initAreaList) {
        this.setState({
          areaList: this.state.initAreaList
        });
      }
      if (this.state.initSiteList) {
        this.setState({
          siteList: this.state.initSiteList
        });
      }
      this.setState({
        cancelled: true,
        entries: _objectSpread({}, this.state.initEntries)
      });
      this.dialogClose();
    });
    // 拠点選択区分用マルチトグル
    _defineProperty(this, "getCodeItemsKaisha", () => {
      const {
        intl
      } = this.props;
      let items = [];
      items.push({
        displayName: intl.formatMessage({
          id: _labelConsts.LABEL.PANDE_LIST_SELECTION
        }),
        value: SITE_SELECT_CODE.SELECT
      });
      items.push({
        displayName: intl.formatMessage({
          id: _labelConsts.LABEL.PANDE_ENTER_SITE
        }),
        value: SITE_SELECT_CODE.INPUT
      });
      return items;
    });
    this.form = /*#__PURE__*/_react.default.createRef();
    const {
      entries: _entries
    } = props;
    let initEntries = {
      siteSelectCd: SITE_SELECT_CODE.SELECT,
      kaishaCd: '',
      areaCd: '',
      siteNo: '',
      tdfkCd: '',
      siteOtherNm: '',
      goutou: '',
      floor: '',
      workspace: '',
      label: ''
    };

    // パラメータの値で項目値を上書きする
    Object.keys(initEntries).forEach(key => {
      initEntries[key] = _entries[key] ? _entries[key] : initEntries[key];
    });

    // state初期化
    this.state = {
      isReady: false,
      dialogOpened: false,
      cancelled: false,
      kaishaList: [],
      areaList: [],
      initAreaList: null,
      siteList: [],
      initSiteList: null,
      entries: _objectSpread({}, initEntries),
      initEntries: _objectSpread({}, initEntries)
    };
  }
  componentDidMount() {
    const {
      callAPI
    } = this.props;
    const {
      entries
    } = this.state;
    this.setState({
      cancelled: false
    });

    // 会社リスト設定
    callAPI(_APIs.KAISHA_SEARCH).then(response => {
      this.setState({
        kaishaList: response.data ? response.data : []
      });
    });

    // 地域リスト設定
    this.getAreaList(true, entries.kaishaCd);

    // 拠点リスト設定
    this.getSiteList(true, entries.kaishaCd, entries.areaCd);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      isReady,
      dialogOpened,
      cancelled,
      entries,
      initEntries,
      kaishaList,
      areaList,
      siteList
    } = this.state;

    // 各項目の準備が完了したら勤務場所のラベルを設定する
    if (!dialogOpened && !isReady) {
      if (entries.siteSelectCd === SITE_SELECT_CODE.INPUT || this.checkReady()) {
        const labelNm = this.getLabelNm(entries, kaishaList, areaList, siteList);
        this.setState({
          isReady: true,
          entries: _objectSpread(_objectSpread({}, entries), {}, {
            label: labelNm
          }),
          initEntries: _objectSpread(_objectSpread({}, initEntries), {}, {
            label: labelNm
          })
        });
        if (this.props.setValue) {
          this.props.setValue('reportTargetWorkplaceLabel', labelNm, {
            shouldValidate: false,
            shouldDirty: false
          });
        }
      }
    }

    // ダイアログを表示していない場合、キャンセルの場合はなにもしない
    if (!dialogOpened || cancelled) {
      return;
    }

    // 「リストから選択する」以外の場合は何もしない
    if (entries.siteSelectCd !== SITE_SELECT_CODE.SELECT) {
      return;
    }

    // 会社変更時は地域、拠点を初期化
    if (entries.kaishaCd !== prevState.entries.kaishaCd) {
      this.setState({
        entries: _objectSpread(_objectSpread({}, entries), {}, {
          areaCd: '',
          siteNo: ''
        }),
        areaList: [],
        siteList: []
      });
      this.getAreaList(false, entries.kaishaCd);
    }

    // 地域変更時は拠点を初期化
    if (entries.areaCd !== prevState.entries.areaCd) {
      this.setState({
        entries: _objectSpread(_objectSpread({}, entries), {}, {
          siteNo: ''
        }),
        siteList: []
      });
      this.getSiteList(false, entries.kaishaCd, entries.areaCd);
    }
  }
  render() {
    var _errors$reportTargetW, _errors$reportTargetW2, _errors$reportTargetW3, _errors$reportTargetW4, _errors$reportTargetW5, _errors$reportTargetW6, _errors$reportTargetW7, _errors$reportTargetW8, _errors$reportTargetW9, _errors$reportTargetW0, _errors$reportTargetW1, _errors$reportTargetW10, _errors$reportTargetW11, _errors$reportTargetW12, _errors$reportTargetW13, _errors$reportTargetW14;
    const {
      intl,
      className,
      getCodeItems,
      isEntry,
      error,
      helperText,
      errors
    } = this.props;
    const {
      dialogOpened,
      kaishaList,
      areaList,
      siteList,
      entries
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.PANDE_WORK_PLACE
      }),
      required: isEntry,
      className: className
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_CButton.default, {
      onClick: this.handleOpen,
      autoWidth: true
    }, intl.formatMessage({
      id: _labelConsts.LABEL.PANDE_WORK_PLACE_SELECT
    }))), /*#__PURE__*/_react.default.createElement(GridLabel, {
      size: {
        xs: true
      }
    }, /*#__PURE__*/_react.default.createElement(_DisplayField.default, {
      className: className,
      placeholder: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_PLEASE_SELECT_REPLACE
      }, {
        0: intl.formatMessage({
          id: _labelConsts.LABEL.PANDE_WORK_PLACE
        })
      }),
      error: !!error,
      helperText: helperText
    }, entries.label ? entries.label : '')))), /*#__PURE__*/_react.default.createElement(_CDialog.default, {
      open: dialogOpened,
      maxWidth: "sm",
      title: intl.formatMessage({
        id: _labelConsts.LABEL.PANDE_WORK_PLACE_SELECT
      }),
      handleClose: this.handleCancel,
      actions: [/*#__PURE__*/_react.default.createElement(_CButton.default, {
        negative: true,
        autoWidth: true,
        onClick: this.handleCancel
      }, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CANCEL
      })), /*#__PURE__*/_react.default.createElement(_CButton.default, {
        autoWidth: true,
        onClick: this.handleSubmit
      }, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_OK
      }))]
    }, /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.PANDE_SITE
      }),
      required: isEntry
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: this.getCodeItemsKaisha(),
      selectedOption: entries.siteSelectCd,
      onSelectOption: this.handleOnChange('siteSelectCd')
    }))), entries.siteSelectCd === SITE_SELECT_CODE.SELECT && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      setNone: true,
      className: className,
      value: entries.kaishaCd,
      onChange: this.handleOnChange('kaishaCd'),
      items: kaishaList.map(data => {
        return {
          displayName: data.kaishaRk,
          value: data.kaishaCd
        };
      }),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW = errors.reportTargetWorkplace) !== null && _errors$reportTargetW !== void 0 && _errors$reportTargetW.kaishaCd),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW2 = errors.reportTargetWorkplace) === null || _errors$reportTargetW2 === void 0 || (_errors$reportTargetW2 = _errors$reportTargetW2.kaishaCd) === null || _errors$reportTargetW2 === void 0 ? void 0 : _errors$reportTargetW2.message
    })), entries.siteSelectCd === SITE_SELECT_CODE.SELECT && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      setNone: true,
      value: entries.areaCd,
      onChange: this.handleOnChange('areaCd'),
      items: areaList.map(data => {
        return {
          displayName: data.areaNm,
          value: data.areaCd
        };
      }),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW3 = errors.reportTargetWorkplace) !== null && _errors$reportTargetW3 !== void 0 && _errors$reportTargetW3.areaCd),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW4 = errors.reportTargetWorkplace) === null || _errors$reportTargetW4 === void 0 || (_errors$reportTargetW4 = _errors$reportTargetW4.areaCd) === null || _errors$reportTargetW4 === void 0 ? void 0 : _errors$reportTargetW4.message
    })), entries.siteSelectCd === SITE_SELECT_CODE.SELECT && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      setNone: true,
      className: className,
      value: entries.siteNo,
      onChange: this.handleOnChange('siteNo'),
      items: siteList.map(data => {
        return {
          displayName: data.siteNm,
          value: data.siteNo
        };
      }),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW5 = errors.reportTargetWorkplace) !== null && _errors$reportTargetW5 !== void 0 && _errors$reportTargetW5.siteNo),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW6 = errors.reportTargetWorkplace) === null || _errors$reportTargetW6 === void 0 || (_errors$reportTargetW6 = _errors$reportTargetW6.siteNo) === null || _errors$reportTargetW6 === void 0 ? void 0 : _errors$reportTargetW6.message
    })), entries.siteSelectCd === SITE_SELECT_CODE.INPUT && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TDFK
      }),
      required: isEntry
    }, /*#__PURE__*/_react.default.createElement(_SuggestBox.default, {
      value: entries.tdfkCd,
      items: getCodeItems(_CodeConsts.CODE.TDFK.KBN, undefined, ['0']),
      onChange: this.handleOnChange('tdfkCd'),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW7 = errors.reportTargetWorkplace) !== null && _errors$reportTargetW7 !== void 0 && _errors$reportTargetW7.tdfkCd),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW8 = errors.reportTargetWorkplace) === null || _errors$reportTargetW8 === void 0 || (_errors$reportTargetW8 = _errors$reportTargetW8.tdfkCd) === null || _errors$reportTargetW8 === void 0 ? void 0 : _errors$reportTargetW8.message
    }))), entries.siteSelectCd === SITE_SELECT_CODE.INPUT && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_BASE_NAME
      }),
      required: isEntry,
      hint: isEntry ? undefined : _labelConsts.LABEL.CORE_FREEWORD_HINT
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: entries.siteOtherNm ? entries.siteOtherNm : '',
      maxLength: 255,
      onChange: this.handleOnChange('siteOtherNm'),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW9 = errors.reportTargetWorkplace) !== null && _errors$reportTargetW9 !== void 0 && _errors$reportTargetW9.siteOtherNm),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW0 = errors.reportTargetWorkplace) === null || _errors$reportTargetW0 === void 0 || (_errors$reportTargetW0 = _errors$reportTargetW0.siteOtherNm) === null || _errors$reportTargetW0 === void 0 ? void 0 : _errors$reportTargetW0.message
    }))), isEntry && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_GOUTOU
      }),
      hint: _labelConsts.LABEL.USERCUSTOM_GOUTOU_INFO
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: entries.goutou,
      maxLength: 50,
      onChange: this.handleOnChange('goutou'),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW1 = errors.reportTargetWorkplace) !== null && _errors$reportTargetW1 !== void 0 && _errors$reportTargetW1.goutou),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW10 = errors.reportTargetWorkplace) === null || _errors$reportTargetW10 === void 0 || (_errors$reportTargetW10 = _errors$reportTargetW10.goutou) === null || _errors$reportTargetW10 === void 0 ? void 0 : _errors$reportTargetW10.message
    })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_FLOOR
      }),
      hint: _labelConsts.LABEL.USERCUSTOM_FLOOR_INFO
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: entries.floor,
      maxLength: 3,
      fullWidth: false,
      onChange: this.handleOnChange('floor'),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW11 = errors.reportTargetWorkplace) !== null && _errors$reportTargetW11 !== void 0 && _errors$reportTargetW11.floor),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW12 = errors.reportTargetWorkplace) === null || _errors$reportTargetW12 === void 0 || (_errors$reportTargetW12 = _errors$reportTargetW12.floor) === null || _errors$reportTargetW12 === void 0 ? void 0 : _errors$reportTargetW12.message
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      component: "span"
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_HIERARCHY
    }))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_WORKSPACE
      }),
      hint: _labelConsts.LABEL.USERCUSTOM_WORKSPACE_INFO
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: entries.workspace,
      maxLength: 50,
      onChange: this.handleOnChange('workspace'),
      error: !!(errors !== null && errors !== void 0 && (_errors$reportTargetW13 = errors.reportTargetWorkplace) !== null && _errors$reportTargetW13 !== void 0 && _errors$reportTargetW13.workspace),
      helperText: errors === null || errors === void 0 || (_errors$reportTargetW14 = errors.reportTargetWorkplace) === null || _errors$reportTargetW14 === void 0 || (_errors$reportTargetW14 = _errors$reportTargetW14.workspace) === null || _errors$reportTargetW14 === void 0 ? void 0 : _errors$reportTargetW14.message
    })))))));
  }
}
WorkplaceInfo.propTypes = {
  isEntry: _propTypes.default.bool,
  entries: _propTypes.default.object.isRequired,
  onChange: _propTypes.default.func.isRequired
};
WorkplaceInfo.defaultProps = {
  isEntry: true
};
const mapDispatchToProps = dispatch => {
  return {
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(WorkplaceInfo))));